import { render, staticRenderFns } from "./detailOrder.vue?vue&type=template&id=1833d069&scoped=true"
import script from "./detailOrder.vue?vue&type=script&lang=js"
export * from "./detailOrder.vue?vue&type=script&lang=js"
import style0 from "./detailOrder.vue?vue&type=style&index=0&id=1833d069&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833d069",
  null
  
)

export default component.exports